import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { Base } from "ui/Scripts/source/framework/base";

interface IFormDecimalProps {
    value: number;
    decimals?: number;
    min?: number;
    max?: number;
    maxLength?: number;
    required?: boolean;
    onChange: (value: number) => void;
}

export const FormDecimal = (props: IFormDecimalProps) => {
    const [value, setValue] = useState("");
    const decimals = Base.isNullOrUndefined(props.decimals) ? 2 : props.decimals;
    const min = Base.isNullOrUndefined(props.min) ? 0 : props.min;

    useEffect(() => {
        if (!Base.isNullOrUndefined(props.value)) {
            let num = Math.max(props.value, min);
            if (!Base.isNullOrUndefined(props.max)) {
                num = Math.min(num, props.max);
            }
            setValue(num.toLocaleFixed(decimals));
        } else {
            setValue("");
        }
    }, [props.value, decimals]);

    const handleChange = (event) => {
        const value: string = event.target.value;
        if (!props.maxLength || !value || value.length <= props.maxLength) {
            setValue(event.target.value);
        }
        setValue(value.substring(0, props.maxLength));
    };

    const handleBlur = (event) => {
        const value: string = event.target.value;
        let newValue = value;
        let result: number = null;
        if (props.required || Base.hasNumber(value)) {
            result = Base.roundToDecimals(Base.strToNumber(value, min, props.max), decimals);
            newValue = result.toLocaleFixed(decimals);
        } else {
            newValue = "";
        }
        setValue(newValue);
        props.onChange(result);
    };

    return (
        <TextField
            value={value}
            InputProps={{ inputProps: { maxLength: props.maxLength } }}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
};